import React, { PropsWithChildren } from "react";
import { mainLogoIconDark } from "../../lib/svg-icons/SvgIcons";
import styles from './auth-container.module.scss';

interface IAuthContainerProps {
    isModal?: boolean;
    isDP?: boolean;
}

const AuthContainer: React.FC<PropsWithChildren<IAuthContainerProps>> = ({isModal = false, isDP = false, children}) => {

    return (
        <div className={styles.auth}>
            {!isModal && (
                <div className="logo-container">
                    <div className='logo'>
                        {mainLogoIconDark}
                        {isDP && (
                            <span>Dealer portal</span>
                        )}
                    </div>
                </div>
            )}
            {children}
        </div>
    );
};

export default AuthContainer;
